import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import { useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import PropTypes from "prop-types";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function TransactionRequests() {
  const [listOfPrincipals, setListOfPrincipals] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    axios({
      method: "get",
      url: process.env.REACT_APP_GET_PRINCIPALS_URL,
      headers: {
        "X-Api-Key": process.env.REACT_APP_X_API_KEY,
        "Access-Control-Allow-Origin": "*",
      },
    }).then((res) => {
      console.log(res.data);
      setListOfPrincipals(res.data);
    });

    console.log("rendered");
  }, []);

  return (
    <div className="transaction-requests">
      <Navbar />
      <Sidebar />
      {/* <div className='header-container'>
                <h3 style={{fontSize: 25}}>Principals</h3>
               </div>
               
               <div className='description-container'>
               <p className='description-paragraph'>As one of the FlexCoin Principals you can see the list of all the FlexCoin's Principals.</p>
               </div>

               <div className='table-container'>
               <h3 style={{paddingTop:20 }}>List Of Principals</h3> */}

      <div className=" h-10 bg-white mx-24 text-gray-500 flex rounded justify-start pl-2 align-middle mt-4">
        <h1 style={{ fontSize: 25 }}>Principals</h1>
      </div>

      <div className="h-12 bg-white mx-24 flex text-gray-500 rounded justify-start pl-2 align-middle mt-4">
        <p className="description-paragraph">
          As one of the Communitas Principals you can see the list of all the
          Communitas's Principals.
        </p>
      </div>

      <div className="flex flex-col bg-white mt-4 mx-24 rounded">
        <h3 className="font-bold text-3xl text-gray-500 pl-2">
          List Of Principals
        </h3>{" "}
        <hr className="container-hr" />
        <div className="table">
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
            colSpan={3}
            count={listOfPrincipals.length}
            rowsPerPage={rowsPerPage}
            page={page}
            sx={{ float: "right" }}
            SelectProps={{
              inputProps: {
                "aria-label": "rows per page",
              },
              native: true,
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
          <TableContainer component={Paper} sx={{ height: "800px" }}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  >
                    Common Name{" "}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  >
                    MSP ID{" "}
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  ></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(rowsPerPage > 0
                  ? listOfPrincipals.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : listOfPrincipals
                ).map((req) => {
                  {
                  }
                  return (
                    <TableRow
                      key={req.commonName}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell
                        scope="row"
                        align="center"
                        sx={{
                          maxWidth: 200,
                          maxHeight: 10,
                          wordBreak: "break-all",
                        }}
                      >
                        {req.commonName}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ maxWidth: 200, wordBreak: "break-all" }}
                      >
                        {req.mspID}
                      </TableCell>
                      <TableCell align="center"></TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
            colSpan={3}
            count={listOfPrincipals.length}
            rowsPerPage={rowsPerPage}
            page={page}
            sx={{ float: "right" }}
            SelectProps={{
              inputProps: {
                "aria-label": "rows per page",
              },
              native: true,
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </div>
      </div>
    </div>
  );
}
